export const CUSTOM_HEADERS = {
  // AccessToken – передается в запросах аутентификации(onSignIn) в виде кастомного response header.
  // Потом передается для запросов требующих авторизации в header Authorization: Bearer ${AccessToken}
  // authJWT middleware verifyToken проверяет AccessToken
  // есть RefreshToken токен который на фронте проверяет если истек AccessToken и не истек RefreshToken забирает с бэкенда новый AccessToken
  Authorization: 'Authorization',
  AccessToken: 'X-Access-Token'.toLowerCase(),
  DeviceId : 'X-Device-Id',
  TabId : 'X-Tab-Id',
}